import React, { useContext, useState } from 'react'
import { get, map } from 'lodash'
import { BookInfo, MenuMaterialsFiltered } from '../../contexts/menuContext'

const ExtraLvl = ({ secondLvl }) => {
  const [status, setStatus] = useState(false)
  const [book, setBook, , setPage] = useContext(BookInfo)
  return (
    <div className={`top-lvl-menu--secondLvl ${status ? 'active' : 'inactive'}`}>
      {get(secondLvl, 'children') ? <h4 onClick={() => { setStatus(!status) }}>
        {get(secondLvl, 'value.title')}
        <div className="caret"/>
      </h4> :
      <h4 onClick={() => {
        setPage(get(secondLvl, 'value.id'))
        setBook({ ...book, childrenMenu: false })
      }}
      >
        {get(secondLvl, 'value.title')}
      </h4>
      }

      <div className="top-lvl-menu--second">
        {map(get(secondLvl, 'children'), (nextLvl, id) => {
          return (
            <div key={id} className="top-lvl-menu--item">
              <button
                type="button"
                className="btn btn-link"
                onClick={() => {
                  setPage(id)
                  setBook({ ...book, childrenMenu: false })
                }}
              >
                {get(nextLvl, 'value.title')}
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}

const MaterialsMain = () => {
  const [materials] = useContext(MenuMaterialsFiltered)
  return (
    <>
      {materials.map((topLvl, index) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} className="top-lvl-menu">
            <h4>
              {get(topLvl, 'value.title')}
            </h4>
            <div>
              {map(get(topLvl, 'children'), (secondLvl, i) => {
                return (<ExtraLvl key={i} secondLvl={secondLvl} />)
              })}
            </div>
          </div>
        )
      })}
    </>
  )
}

export default MaterialsMain
